export const CLIENT_COMP_VERSION = "1.1.0";
